import Select, { Props } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { useThemeStore } from '../../state/theme';

export type SelectOption = {
  value: string;
  label: string;
};

interface SelectComponentProps<Option extends SelectOption> extends Props<Option, boolean> {
  isCreatable?: boolean;
}

const SelectComponent = <Option extends SelectOption>({
  isCreatable = false,
  ...props
}: SelectComponentProps<Option>) => {
  const { isDarkMode } = useThemeStore();

  const Component = isCreatable ? CreatableSelect : Select;

  return (
    <Component<Option, boolean>
      {...props}
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: isDarkMode ? '#374151' : 'white',
          borderColor: isDarkMode ? '#4B5563' : '#D1D5DB',
        }),
        menu: (base) => ({
          ...base,
          backgroundColor: isDarkMode ? '#374151' : 'white',
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: isDarkMode
            ? state.isFocused
              ? '#4B5563'
              : '#374151'
            : state.isFocused
              ? '#F3F4F6'
              : 'white',
          color: isDarkMode ? 'white' : 'black',
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: isDarkMode ? '#4B5563' : '#E5E7EB',
          margin: '2px 4px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }),
        multiValueLabel: (base) => ({
          ...base,
          color: isDarkMode ? 'white' : 'black',
        }),
        singleValue: (base) => ({
          ...base,
          color: isDarkMode ? 'white' : 'black',
        }),
        input: (base) => ({
          ...base,
          color: isDarkMode ? 'white' : 'black',
        }),
        valueContainer: (base) => ({
          ...base,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          flexWrap: 'nowrap',
          padding: '2px 8px',
        }),
      }}
    />
  );
};

export default SelectComponent;
